module.exports = __webpack_public_path__ + "img/facilities_06.c9fdeade.jpg";